import { action, decorate, observable } from 'mobx';
import ItemsData from './items-data';
import OrderData from './order-data';
import PagingData from './paging-data';
import QueryData from './query-data';

class ListData {
  pagingData = new PagingData();

  itemsData = new ItemsData();

  orderData = new OrderData();

  queryData = new QueryData();

  resetListData() {
    this.pagingData.resetPagingData();
    this.itemsData.resetItemsData();
  }

  dataLoaded(data, pagingData) {
    this.itemsData.setItemsData(data);
    if (pagingData) {
      this.pagingData.setPagingData(pagingData);
    } else {
      this.pagingData = null;
    }
  }
}

decorate(ListData, {
  pagingData: observable,
  itemsData: observable,
  orderData: observable,
  queryData: observable,
  resetListData: action,
  dataLoaded: action
});

export default ListData;
